import React, { Component } from 'react';
/** Personal */
import { getDom } from '../NormalStem';

class StemLine extends Component {
    render() {
        const { options } = this.props;

        return (
            <div style={{ position: 'relative' }}>
                <div className='guide-list'>
                    {
                        options.left.map(item =>
                            <p
                                className='guide-item'
                                data-id={item.id}
                                key={item.id}>{item.content}</p>
                        )
                    }
                </div>
                <canvas
                    id={`canvas`} 
                    width={500} 
                    height={0} 
                    style={{ width: 250, height: 0, verticalAlign: 'top' }} />
                <div className='guide-list'>
                    {
                        options.right.map(item =>
                            <p
                                className='guide-item'
                                data-id={item.id}
                                key={item.id}>{item.content}</p>
                        )
                    }
                </div>
            </div>
        )
    }
}

class Stem extends Component {
    render() {
        const { stem } = this.props;

        return (
            <div>
                {
                    stem.map((para, i) => {
                        return <div className={para.style} key={i}>
                            {
                                para.style === 'math_matching' ?
                                    <StemLine options={para.children[0]} /> :
                                    para.children.map((child, index) =>
                                        getDom(child, para.style, index)
                                    )
                            }
                        </div>
                    })
                }
            </div>
        )
    }
}

export default Stem;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/pair/Stem.js